import { DecimalPipe, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgxMaskPipe } from 'ngx-mask';

import { TransactionLimitItem } from '@shared/models';
import { AmountPipe } from '@shared/pipes/amount.pipe';

import { PrefixPipe } from '../../../pipes/prefix.pipe';

@Component({
  selector: 'app-transaction-limit-item',
  templateUrl: './transaction-limit-item.component.html',
  styleUrls: ['./transaction-limit-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, DecimalPipe, PrefixPipe, NgxMaskPipe, AmountPipe],
})
export class TransactionLimitItemComponent {
  @Input() limitItem!: TransactionLimitItem;

  get isSingle(): boolean {
    return this.limitItem.type === 'single';
  }
}
